export default __webpack_public_path__ + "static/media/digital-printing-technology.ee81d256.svg";